import styled from 'styled-components'

import { helpers } from 'styles'

export const Wrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 50%;
	column-gap: 46px;
	padding-bottom: 64px;
	border-bottom: 1px solid ${helpers.color.separator};

	&:last-of-type {
		border-bottom: none;
	}

	@media only screen and (max-width: 1250px) {
		grid-template-columns: 1fr;
	}

	/* Some grid non-sense where if you don't set the min-width on elements
	with a pre tag it does not respect the constraints properly */
	& > * {
		min-width: 0;
	}
`
